/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpResponse, HttpContext, HttpParams } from '@angular/common/http';
import { DataBaseService } from '../data-base-service';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { JobStatusResponseDto } from '../models/job-status-response-dto';

@Injectable({ providedIn: 'root' })
export class JobControllerService extends DataBaseService {

  /**
   * Path part for operation jobControllerGetJobStatusByMessageId
   */
  static readonly JobControllerGetJobStatusByMessageIdPath = '/v1/job/{messageId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getJobStatusByMessageId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getJobStatusByMessageId$Response(params: {
    messageId: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<JobStatusResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, JobControllerService.JobControllerGetJobStatusByMessageIdPath, 'get');
    if (params) {
      rb.path('messageId', params.messageId, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<JobStatusResponseDto>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getJobStatusByMessageId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getJobStatusByMessageId(params: {
    messageId: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<JobStatusResponseDto> {

    return this.getJobStatusByMessageId$Response(params).pipe(
      map((r: StrictHttpResponse<JobStatusResponseDto>) => r.body as JobStatusResponseDto)
    );
  }

}
